export const environment = {
  production: false,
  apiUrl: 'https://schoolmgtsystem.duckdns.org/api/v1',
  // apiUrl: 'http://localhost:3000/api/v1'
};
